module.exports = __webpack_public_path__ + "5b5244061ce091308e6224f88878dc37.mp3";